import { Component, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges } from "@angular/core";
import { IVeriMapComponent } from "@directives/_map/veriMap/veriMapComponent/veriMap.component";
import { MapService } from "@services/map.service";
//import { IPolygon } from "@typings/google.maps.angular";

@Component({
    selector: "ui-gmap-polygon",
    template: ""
})
export class UIGmapPolygonComponent implements OnChanges, OnDestroy{

    @Input() polygon: any;

    veriMap: IVeriMapComponent;
    googlePolygon: google.maps.Polygon;

    constructor(
        private readonly elementRef: ElementRef<HTMLElement>,
        private readonly mapService: MapService) {
    }

    ngOnChanges(onChangesObj: SimpleChanges) {
        if (!this.veriMap) {
            this.veriMap = this.mapService.findVeriMap(this.elementRef);
        }

        if (this.googlePolygon) {
            this.googlePolygon.setMap(null);
        }

        if (this.polygon == null) {
            return;
        }

        //if (this.events) {
        //    console.warn("Marker doesnt support events at the moment");
        //}

        var path: google.maps.LatLng[] = [];
        this.polygon.path.forEach(p => {
            path.push(new google.maps.LatLng(p.latitude, p.longitude));
        });

        var polygonOptions: google.maps.PolygonOptions = {
            paths: path,
            map: this.veriMap.getMap()
        };

        if (this.polygon.fill) {
            polygonOptions.fillColor = this.polygon.fill.color;
            polygonOptions.fillOpacity = this.polygon.fill.opacity;
        }

        if (this.polygon.stroke) {
            polygonOptions.strokeColor = this.polygon.stroke.color;
            polygonOptions.strokeWeight = this.polygon.stroke.weight;
        }

        this.googlePolygon = new google.maps.Polygon(polygonOptions);
    }

    ngOnDestroy() {
        if (this.googlePolygon) {
            this.googlePolygon.setMap(null);
        }
    }
}
